import React, { useState } from "react";
// import "./FilterBar.css"; // Assuming you want to keep styles separate

const FilterBar = () => {
  const [activeFilter, setActiveFilter] = useState("Bonus Money");

  const filters = [
    "Bonus Money",
    "Spin Bonus",
    "Live Casino",
    "Sports Games",
    "Lorem Ips",
    "Lorem Ips",
    "Lorem Ips",
  ];

  return (
    <div className="filter-bar-area">
      <div className="filter-bar-lavel">Filter By</div>
      <div className="filter-bar">
        {filters.map((filter, index) => (
          <button
            key={index}
            className={filter === activeFilter ? "active" : ""}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;
